export default __webpack_public_path__ + "static/media/pilz-13.871b13fa.png";